/*
 * Website: https://www.4myth.com
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Copyright © 2016-2022 All rights reserved.
 * MyTh Ahmed Fayez
 */

import { Tools } from '@helpers/Tools'
import { extend } from 'vee-validate/dist/vee-validate.full.esm'

extend('int', v => Tools.isNumeric(Tools.fromArabicNumber(v)))

extend('mobile', v => Tools.isKsaMobile(v))

export default extend
